
import { Payload } from "@/types/profile";

export const advancedPayloads: Payload[] = [
  // AirPrint payloads
  {
    id: "airprint",
    name: "AirPrint",
    description: "Configure AirPrint printers",
    category: "Advanced",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "airPrintIPAddress",
        name: "IP Address",
        type: "text",
        required: true,
        description: "AirPrint printer IP address"
      },
      {
        id: "airPrintResourcePath",
        name: "Resource Path",
        type: "text",
        required: true,
        description: "AirPrint printer resource path"
      }
    ]
  },
  
  // Custom Settings payloads
  {
    id: "custom-settings",
    name: "Custom Settings",
    description: "Configure custom settings via preference domain",
    category: "Advanced",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "preferenceDomain",
        name: "Preference Domain",
        type: "text",
        required: true,
        description: "The preference domain (e.g., com.example.app)"
      },
      {
        id: "customSettings",
        name: "Custom Settings",
        type: "textarea",
        required: true,
        description: "Custom settings in JSON format"
      }
    ]
  },
  
  // Extensions payloads
  {
    id: "extensions",
    name: "Extensions",
    description: "Configure system extensions",
    category: "Advanced",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "allowedTeamIdentifiers",
        name: "Allowed Team Identifiers",
        type: "textarea",
        required: false,
        description: "Team identifiers allowed to provide extensions"
      },
      {
        id: "allowedSystemExtensionTypes",
        name: "Allowed System Extension Types",
        type: "textarea",
        required: false,
        description: "Types of system extensions to allow"
      }
    ]
  },
  
  // Login Items payloads
  {
    id: "loginItems",
    name: "Login Items",
    description: "Configure items that launch at login",
    category: "Advanced",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "items",
        name: "Login Items",
        type: "textarea",
        required: true,
        description: "List of paths to applications, each on a new line"
      },
      {
        id: "hideItems",
        name: "Hide Items",
        type: "boolean",
        required: false,
        default: false,
        description: "Hide the items when launched"
      }
    ]
  }
];
